<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-divider>{{ $T('国歌上传') }}</el-divider>
      <p class="hint">{{ $T('国歌上传说明') }}</p>

      <el-form label-position="top" class="anthem-form">
        <el-form-item :label="$T('音频文件')">
          <FileUploader
            :fileList="nationalAnthemList"
            :limit="5"
            accept=".mp3,.wav,.m4a,.aac,.ogg,audio/*"
          ></FileUploader>
        </el-form-item>
      </el-form>

      <div class="footer-button">
        <el-button type="primary" :loading="saveLoading" @click="onSave">{{ $T('保存') }}</el-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.hint {
  font-size: 14px;
  color: #606266;
  margin: 0 0 16px;
  line-height: 1.5;
}
.anthem-form {
  max-width: 560px;
}
.footer-button {
  margin-top: 20px;
  text-align: center;
}
</style>

<script>
import FileUploader from '@/components/picker/FileUploader.vue';

export default {
  name: 'SaiApplyFormStep7',
  components: {
    FileUploader,
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        id: 0,
      },
      nationalAnthemList: [],
    };
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    document.title = this.$T('国歌上传');
    if (this.formData.id) {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      this.$api.post(
        '/api/isai/step7detail',
        { id: this.formData.id },
        (res) => {
          const data = res.data || {};
          const list = data.national_anthem;
          this.nationalAnthemList = Array.isArray(list) ? list.slice() : [];
        },
        (res) => {
          this.$message.error(res.msg || this.$T('加载失败'));
        },
      );
    },
    onSave() {
      this.saveLoading = true;
      const payload = Array.isArray(this.nationalAnthemList) ? this.nationalAnthemList.slice() : [];
      this.$api.post(
        '/api/isai/anthemSave',
        {
          baoming_id: this.formData.id,
          national_anthem: JSON.stringify(payload),
        },
        () => {
          this.saveLoading = false;
          this.$message.success(this.$T('保存成功'));
          this.fetch();
          rbLink({
            name: 'ISaiApplyDetail',
            query: {
              id: this.formData.id,
            },
          }, 'back');
        },
        (res) => {
          this.saveLoading = false;
          this.$message.error(res.msg || this.$T('保存失败'));
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep7.vue?5a1099fa